export const STORAGE_KEYS = {
  IDNS: 'fakeIDNData',
  DEPARTMENTS: 'fakeDepartmentData',
  PATIENTS: 'fakePatientData',
  ADMIN_USERS: 'fakeAdminUserData',
} as const;
